import React from 'react';
const coverage = [{
  label: 'Calendar',
  body: '52 weeks · Mon, Wed, Fri · 156 sessions in 13 progressive blocks'
}, {
  label: 'Every session',
  body: '45 minutes: warm-up, main block with the timing math, finisher, cool-down'
}, {
  label: 'Formats',
  body: 'EMOM, E2MOM, AMRAP, Tabata, chippers, partner and team workouts'
}, {
  label: 'Equipment',
  body: 'Dumbbells, kettlebells, bands, mats — with bodyweight swaps'
}, {
  label: 'Levels',
  body: 'Beginner / Regular / Advanced on every page — same clock for all'
}, {
  label: 'Progress',
  body: 'Week 1 baseline, re-tested in Week 52. Deload weeks built in'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-gold bg-navy-mid" data-id="element-186" data-mp="2n50gpnsjv1qs">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-187" data-mp="1ummrgcla4o3b">
        <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold" data-id="element-188" data-mp="1ukjpqvarl6ir">
          The mechanism
        </p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-189" data-mp="1b17cggd300cc">
          The 0-Decision Framework™
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/75" data-id="element-190" data-mp="1jtj2w2873nsb">
          2,500 workouts are 2,500 decisions. A library doesn&apos;t remove the
          work — it moves it: you still open, search, pick, sequence and adapt,
          every single week. The Decided Bootcamp makes the decision once, in
          advance, and ties it to a class day. Find today, print the page, clip
          it to your clipboard and coach it.
        </p>

        <ul className="mt-8 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-191" data-mp="1116twwn1do97">
          {coverage.map(item => <li key={item.label} className="rounded-lg border border-navy-line bg-white/5 px-4 py-3" data-id="element-192" data-mp="15zi10zly5knq">
              <span className="block text-[11px] font-bold uppercase tracking-widest text-gold" data-id="element-193" data-mp="2hg8biuxekyn5">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-194" data-mp="1ruysrifdm0w8">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}